/* eslint-disable */
import { ALL_DEBAR_USERS_DATA } from "../actions/debarActionTypes";

const initialState = {
    allDebarUsersList: [],
}

export default function debarManagementReducer(state = initialState, action) {
    switch (action.type) {
        case ALL_DEBAR_USERS_DATA:
            return {
                ...state,
                allDebarUsersList: action.payload
            }
        default:
            return state;
    }
}